// import * as React from "react";
// import { useEffect, useState } from "react";
// import { IconButton, Pagination } from "@mui/material";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// // import axios from "axios";
// import { Inactive, Active } from "../../shared/ActivaInactive";
// import axiosInstance, { baseUrl } from "../../config/axios";
// import moment from "moment/moment";
// import { Delete } from "@mui/icons-material";
// import { toast } from "react-toastify";
// const CustomerList = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPage, setTotalPage] = useState(null);
//   const storeId = localStorage.getItem("store_id");
//   const [data, setData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   const specificationTypeData = () => {
//     // customer-list/?store_id=${storeId}&page=${page}&search=${searchQuery}
//     axiosInstance
//       .post(
//         `api/admin/show-all-customer-profile-data/`,
//         { search: searchQuery, page: page },
//         {
//           headers: {
//             Token: localStorage.getItem("Token"),
//           },
//         },
//       )
//       .then((response) => {
//         setData(response?.data?.data);
//         setTotalPage(response?.data?.total_pages);
//         setCurrentPage(response?.data?.current_page);
//       })
//       .catch((error) => {
//         console.log("", error);
//       });
//   };

//   const DeleteData = (id) => {
//     // customer-list/?store_id=${storeId}&page=${page}&search=${searchQuery}
//     axiosInstance
//       .delete(
//         `api/admin/show-all-customer-profile-data/`,
//         {
//           data: {
//             customer_id: id,
//           },
//         },
//         {
//           headers: {
//             Token: localStorage.getItem("Token"),
//           },
//         },
//       )
//       .then((response) => {
//         specificationTypeData();
//         toast.success(response?.data?.message);
//       })
//       .catch((error) => {
//         console.log("", error);
//       });
//   };

//   useEffect(() => {
//     specificationTypeData();
//   }, [page, searchQuery]);

//   const handleChange = (event, value) => {
//     setPage(value);
//   };

//   return (
//     <div className=" !bg-slate-100">
//       <div className="flex justify-between">
//         <div className="p-2">
//           <p className="text-xl !text-black font font-bold">
//             Manage Customer List
//           </p>
//         </div>
//         <div className="p-2 pt-5">
//           {/* <Button variant="outlined" color="primary" onClick={handleOpen}>
//             <AddIcon />
//             Add Product Specification
//           </Button> */}
//         </div>
//       </div>
//       <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
//         <div className="flex items-center justify-between my-2">
//           <span className="flex  gap-3">
//             <input
//               type="text"
//               value={searchQuery}
//               className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
//               placeholder="search"
//               style={{ border: "1px solid black" }}
//               onChange={(event) => setSearchQuery(event.target.value)}
//             />
//           </span>
//           <span>
//             <div className="text-red-500 mx-3">
//               {/* <Modal
//                 open={open}
//                 onClose={handleClose}
//                 aria-labelledby="child-modal-title"
//                 aria-describedby="child-modal-description"
//               >
//                 <Box
//                   sx={{ ...style, width: 430 }}
//                   className="rounded-2xl !border-0"
//                 >
//                   <div
//                     id="child-modal-title "
//                     className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
//                   >
//                     {ids === null
//                       ? "Add Product Specification "
//                       : "Update Product Specification "}
//                   </div>
//                   <div className="w-full">
//                     {ids === null ? (
//                       <>
//                         <div className="">Select Main Category :</div>
//                         <FormControl fullWidth>
//                           <Select
//                             id="demo-simple-select"
//                             size="small"
//                             name="main_category_id"
//                             className="!mt-1"
//                             value={categoryId}
//                             onChange={(event) =>
//                               setCategoryId(event.target.value)
//                             }
//                           >
//                             {categoryData?.map((elem) => (
//                               <MenuItem value={elem?.id}>
//                                 {elem?.category}
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </>
//                     ) : null}

//                     <div className="mt-2">Specification Name :</div>
//                     <input
//                       size="small"
//                       value={name}
//                       onChange={(event) => setName(event.target.value)}
//                       id="outlined-basic"
//                       className="!w-[100%] !mt-1 border rounded border-gray-300 p-1"
//                       name="product_name"
//                     />
//                   </div>
//                   <Button
//                     onClick={hangleCancel}
//                     variant="contained"
//                     color="warning"
//                     className="!py-2 !mt-3"
//                   >
//                     CANCEL
//                   </Button>
//                   <Button
//                     variant="contained"
//                     type="submit"
//                     color="success"
//                     className="!py-2 !px-5 !font-bold !mt-3 !float-right"
//                     onClick={submitCategory}
//                   >
//                     {ids == null ? "ADD" : "UPDATE"}
//                   </Button>
//                 </Box>
//               </Modal> */}
//             </div>
//           </span>
//         </div>
//         <TableContainer
//           component={Paper}
//           sx={{ width: "100%" }}
//           className="!text-black h-[70vh] !mx-auto !bg-white overflow-auto"
//         >
//           <Table stickyHeader aria-label="simple table" size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   ID
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   <div className="w-36">CUSTOMER NAME</div>
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   EMAIL
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   MOBILE
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   JOIN DATE
//                 </TableCell>

//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   <div className="w-40">PROFILE PICTURE</div>
//                 </TableCell>

//                 <TableCell
//                   style={{
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   IS ACTIVE
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   ACTION
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody className="!bg-red">
//               {data &&
//                 data?.map((row, index) => (
//                   <TableRow key={row.id} className="!text-slate-700">
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {index + 1}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.first_name ? row?.first_name : "--"}{" "}
//                       {row?.last_name}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.email ? row?.email : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.mobile_no ? row?.mobile_no : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.date_joined
//                         ? moment(row?.date_joined).format("DD-MM-YYYY")
//                         : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.profile_picture ? (
//                         <img
//                           src={row?.profile_picture}
//                           className="h-8 w-8 mx-auto"
//                         />
//                       ) : (
//                         "--"
//                       )}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.is_active ? <Active /> : <Inactive />}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       <IconButton onClick={() => DeleteData(row?.id)}>
//                         <Delete color="error" />
//                       </IconButton>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//             </TableBody>
//           </Table>

//           {/* ) :
//           <div class="spinner"></div>
//           } */}
//         </TableContainer>

//         <div className=" flex items-end p-4  justify-end">
//           {/* <Pagination
//             page={currentPage}
//             size="small"
//             count={totalPage}
//             variant="outlined"
//             color="primary"
//             onChange={handleChange}
//           /> */}

//           <Pagination
//             count={totalPage}
//             page={currentPage}
//             variant="outlined"
//             shape="rounded"
//             onChange={handleChange}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomerList;

import * as React from "react";
import { useEffect, useState } from "react";
import { IconButton, Pagination } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import axios from "axios";
import { Inactive, Active } from "../../shared/ActivaInactive";
import axiosInstance, { baseUrl } from "../../config/axios";
import moment from "moment/moment";
import { Delete } from "@mui/icons-material";
import { toast } from "react-toastify";

const cellSx = {
  borderRight: "1px solid #D0D0D0",
  fontFamily: "'Poppins', sans-serif",
  fontSize: "11px",
  padding: "3px 8px",
  textAlign: "center",
  lineHeight: 1.2,
};

const headSx = {
  ...cellSx,
  fontWeight: 700,
  color: "#1f2937",
  whiteSpace: "nowrap",
};

const CustomerList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const storeId = localStorage.getItem("store_id");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const specificationTypeData = () => {
    // customer-list/?store_id=${storeId}&page=${page}&search=${searchQuery}
    axiosInstance
      .post(
        `api/admin/show-all-customer-profile-data/`,
        { search: searchQuery, page: page },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setData(response?.data?.data);
        setTotalPage(response?.data?.total_pages);
        setCurrentPage(response?.data?.current_page);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  const DeleteData = (id) => {
    // customer-list/?store_id=${storeId}&page=${page}&search=${searchQuery}
    axiosInstance
      .delete(
        `api/admin/show-all-customer-profile-data/`,
        {
          data: {
            customer_id: id,
          },
        },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        specificationTypeData();
        toast.success(response?.data?.message);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    specificationTypeData();
  }, [page, searchQuery]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Customer List
          </p>
        </div>
        <div className="p-2 pt-5"></div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-1">
          <span className="flex gap-3">
            <input
              type="text"
              value={searchQuery}
              className="mx-3 !w-56 px-2 rounded-md text-xs"
              placeholder="search"
              style={{ border: "1px solid black", height: 28 }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3"></div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          sx={{ width: "100%", maxHeight: "74vh" }}
          className="!text-black !mx-auto !bg-white overflow-auto"
        >
          <Table stickyHeader aria-label="simple table" size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={headSx}>ID</TableCell>
                <TableCell sx={headSx}>CUSTOMER NAME</TableCell>
                <TableCell sx={headSx}>EMAIL</TableCell>
                <TableCell sx={headSx}>MOBILE</TableCell>
                <TableCell sx={headSx}>JOIN DATE</TableCell>
                <TableCell sx={headSx}>PROFILE PICTURE</TableCell>
                <TableCell sx={headSx}>IS ACTIVE</TableCell>
                <TableCell sx={{ ...headSx, borderRight: "none" }}>
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} hover className="!text-slate-700">
                    <TableCell sx={cellSx}>{index + 1}</TableCell>
                    <TableCell sx={cellSx}>
                      {row?.first_name ? row?.first_name : "--"}{" "}
                      {row?.last_name}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.email ? row?.email : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.mobile_no ? row?.mobile_no : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.date_joined
                        ? moment(row?.date_joined).format("DD-MM-YYYY")
                        : "--"}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      {row?.profile_picture ? (
                        <img
                          src={row?.profile_picture}
                          alt=""
                          className="h-6 w-6 mx-auto object-cover"
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell sx={cellSx}>
                      <div className="flex justify-center scale-75 origin-center">
                        {row?.is_active ? <Active /> : <Inactive />}
                      </div>
                    </TableCell>
                    <TableCell sx={{ ...cellSx, borderRight: "none" }}>
                      <IconButton
                        size="small"
                        sx={{ p: 0.25 }}
                        onClick={() => DeleteData(row?.id)}
                      >
                        <Delete sx={{ fontSize: 16 }} color="error" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div className="flex items-end px-4 py-2 justify-end">
          <Pagination
            count={totalPage}
            page={currentPage}
            size="small"
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerList;
